module.exports = __webpack_public_path__ + "static/media/intro-zoom@2x.db81ad5a.jpg";